// screens/DriverTransferRequest/DriverTransferRequestComponents/DriverTransferRequestLoadingSnapshot.jsx
import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Stack,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useDriverTransferRequestDetailContext } from "contexts/DriverTransferRequestDetailContext";


const DriverTransferRequestLoadingSnapshot = () => {
  const { transferRequestDetail, loadingTransferRequest } =
    useDriverTransferRequestDetailContext();

  const snapshot = transferRequestDetail?.loadingSnapshot ?? [];

  if (loadingTransferRequest) return null;

  return (
    <Box padding={3}>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        Loading Snapshot ({snapshot.length})
      </Typography>

      {snapshot.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No loading snapshot available.
        </Typography>
      ) : (
        snapshot.map((item, index) => (
          <Accordion key={item?.loadingId?._id ?? index} disableGutters>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="body2" fontWeight={500}>
                Loading #{index + 1} —{" "}
                {item?.loadingId?.loadingId ??
                  item?.loadingId?._id ??
                  "Unknown Loading"}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="caption" color="text.secondary" mb={1} display="block">
                Shipments ({item?.shipmentIds?.length ?? 0})
              </Typography>
              <Stack direction="row" flexWrap="wrap" gap={1}>
                {item?.shipmentIds?.length > 0 ? (
                  item.shipmentIds.map((shipment) => (
                    <Chip
                      key={shipment?._id}
                      label={shipment?.shipmentId ?? shipment?._id}
                      size="small"
                      variant="outlined"
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No shipments.
                  </Typography>
                )}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </Box>
  );
};

export default DriverTransferRequestLoadingSnapshot;